const numberFormatter = new Intl.NumberFormat("fr-CA", { maximumFractionDigits: 3 });
const isMissing = (value) => value == null || value === "";

function ouiNon(value) {
  if (isMissing(value)) return "—";
  if (value === true || String(value).trim().toLowerCase() === "oui") return "Oui";
  if (value === false || String(value).trim().toLowerCase() === "non") return "Non";
  return String(value);
}

export function driverOptionDetails(person, period = "day") {
  const evening = period === "evening";
  const label = evening ? "Soir" : "Jour";
  const start = person?.[evening ? "evening_start_time" : "start_time"];
  const hours = person?.[evening ? "evening_max_work_hours" : "max_work_hours"];
  return [
    { label: `Début ${label}`, value: isMissing(start) ? "Valeur par défaut" : String(start).slice(0, 5) },
    { label: `Heures max ${label}`, value: isMissing(hours) ? "Valeur par défaut" : `${numberFormatter.format(hours)} h` },
  ];
}

export function trailerOptionDetails(trailer) {
  const capacity = trailer?.capacity_tons;
  return [
    { label: "Capacité", value: isMissing(capacity) ? "—" : `${numberFormatter.format(capacity)} t` },
    { label: "Aspirateur", value: ouiNon(trailer?.aspirator) },
    { label: "Produit associé", value: trailer?.preferred_grain_type || "—" },
    { label: "Pool preload", value: ouiNon(trailer?.is_initial_preload_enabled) },
  ];
}

export function tractorOptionDetails(tractor) {
  const type = tractor?.truck_type;
  return [
    { label: "Type", value: type ? type.charAt(0).toUpperCase() + type.slice(1) : "—" },
    { label: "Ontario", value: ouiNon(tractor?.ontario) },
  ];
}
